import { tickStep } from "d3"

export interface FrequencyTicks {
	tickValues: string[]
	formatTick: (value: string) => string
}

const FREQUENCY_TICK_COUNT = 5
const LABEL_MATCH_TOLERANCE_HZ = 1e-6

// Ticks sit at nice frequencies (~FREQUENCY_TICK_COUNT steps over the labels' extent),
// and only on rows whose label is exactly that frequency, so a tick never shows a
// value its row does not have.
export const getFrequencyTicks = (labels: string[]): FrequencyTicks => {
	const finiteValues = labels.map(Number).filter(value => Number.isFinite(value))

	if (finiteValues.length === 0) {
		return { tickValues: [], formatTick: value => value }
	}

	const minValue = Math.min(...finiteValues)
	const maxValue = Math.max(...finiteValues)
	const step = maxValue > minValue ? tickStep(minValue, maxValue, FREQUENCY_TICK_COUNT) : 1

	const tickValues = labels.filter(label => {
		const value = Number(label)
		return Number.isFinite(value) && Math.abs(value - Math.round(value / step) * step) < LABEL_MATCH_TOLERANCE_HZ
	})

	const formatTick = (value: string): string => {
		const numericValue = Number(value)
		return Number.isNaN(numericValue) ? value : numericValue.toString()
	}

	return { tickValues, formatTick }
}
